<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-form
                ref="form"
                v-model="valid"
        >
            <v-row
                    v-for="selectedVariable in variables"
                    :key="selectedVariable.id"
            >
                <v-col cols="5" md12 class="py-0">
                    <v-text-field
                            label="Переменная"
                            readonly
                            :value="getVariableById(selectedVariable.id).title"
                            hide-selected
                    ></v-text-field>
                </v-col>
                <v-col cols="1">
                    <span class="font-weight-bold">=</span>
                </v-col>
                <v-col cols="5" md12 class="py-0">
                    <v-text-field
                            label="Значение после нажатия"
                            v-model="selectedVariable.change_after_press"
                            :value="selectedVariable.change_after_press"
                            @input="$emit('changeValueVariable', { variableId: selectedVariable.id, value: selectedVariable.change_after_press })"
                    ></v-text-field>

                </v-col>
                <v-col cols="1">
                    <v-btn
                            @click="$emit('deleteVariable', selectedVariable.id)"
                            icon
                            x-small
                            color="error"
                    >
                        <v-icon>delete</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-menu right top :offset-x="true">
                    <template v-slot:activator="{ on }">
                        <v-btn
                                light
                                icon
                                v-on="on"
                                x-small
                                color="success"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                    </template>
                    <v-list style="max-height: 300px"
                    class="overflow-y-auto">
                        <v-list-item
                                v-for="selectedVariable1 in unselectedVariables"
                                :key="selectedVariable1.id"
                                @click="$emit('selectVariable', selectedVariable1)"
                        >
                            <v-list-item-title>{{selectedVariable1.title}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'VariablesSelectForm',
    props: ['variables'],

    components: {},
    data() {
        return {
            isActive: false,
            variableModel: { id: null },
            selectedMailingGroups: { excepts: [], group_ids: [] },
            datePicker: '',
            attachments: [],
            visAttachmentForm: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            jumpInfoDialog: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 700) || 'Максимальная длина сообщения 500 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.'
            },
            valid: false,
            loadVariablesInForm: false
        }
    },
    methods: {
        saveValue() {
            this.$store.dispatch('scenarios/variableCreate', this.variableModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.variableModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbar = true
            })
        },
        loadModel(variableId = null) {
            if (variableId === null) {
                this.variableModel = Object.assign({}, this.variableDefault)
            } else {
                this.variableModel = Object.assign({}, this.getVariableById(variableId))
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        ...mapState(['scenarios']),
        ...mapGetters({
            variableDefault: 'scenarios/variableDefault',
            getVariableById: 'scenarios/getVariableById',
            mailingGroups: 'mailingGroups/mailingGroups',
            keyboards: 'keyboards/keyboards'
        }),
        mainValid() {
            return (this.variableModel.type_list === 1 ? (this.variableModel.group_ids.length === 0) : false)
        },
        unselectedVariables() {
            return this.scenarios.variables.filter(variable => {
                let index = this.variables.findIndex(variableInButton => variableInButton.id === variable.id)
                return index === -1
            })
        }
    },
    created() {
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
